import classNames from 'classnames';
import React, { FC } from 'react';
import styles from './GalleryLightbox.module.scss';

export const GalleryLightboxVideo: FC = ({ children }) => {
	return (
		<div className={classNames(styles.galleryLightboxVideo, 'd-flex w-100 h-100')}>
			<div className="m-auto">{children}</div>
		</div>
	);
};
